export function validatePassMappings(
  passNames: string[],
  passMappings: Record<string, string>
): { valid: boolean; unmapped: string[] } {
  const unmapped = passNames.filter((name) => !(passMappings[name] ?? '').trim())
  return { valid: unmapped.length === 0, unmapped }
}
